import { useState, useEffect, memo, useRef, useMemo } from 'react';

import { SoundOutlined, LoadingOutlined } from '@ant-design/icons';
import { MultiAccurate, SubAccurate } from '@lcsc-design/utils/decimal';
import { asyncCheckNoPriceEnquiry } from '@lcsc-ui/apis/order';
import PriceInquiryModal from '@lcsc-ui/components/PriceInquiryModal';
import useUserStore from '@lcsc-ui/store/user';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import lcMsgTips from '@lcsc-ui/utils/lcMsgTips';
import sendAxios from '@lcsc-ui/utils/request';
import Utils from '@lcsc-ui/utils/Utils';
import { message, Popover, Spin } from 'antd';

import BuyGroupProductDialog from './components/buyGroupProductDialog';
import CountdownModel from './components/countdownModel';
import DeliveryTime from './components/deliveryTime';
import InventoryComponents from './components/inventoryComponents';
import ItemRightSkeleton from './components/ItemRightSkeleton';
import NumberOfPurchases from './components/numberOfPurchases';
import OvseaProductDiscountActivity from './components/ovseaProductDiscountActivity';
import PriceListPage from './components/priceListPage';
import ProductDiscountActivity from './components/productDiscountActivity';
import SecondKillDialog from './components/secondKillDialog';
import SecondKillModel from './components/secondKillModel';

import API from '@/apis';
import SellAbroadModel from '@/components/sellAbroadModel';
import { lcBookProvider } from '@/constants';
import useProductStore from '@/store/product';

export default function ItemDetailRightPage({ data }) {
  const fromZone = useUserStore((state) => state.fromZone);
  const projectConfigVO = useUserStore((state) => state.projectConfigVO);
  const { userInfo, updateUserInfo } = useUserStore();
  const { productRecord } = data;
  const [discountMoney, setDiscountMoney] = useState(null);
  const [gdBuyNumber, setGdBuyNumber] = useState(null);
  const [overseaBuyNumber, setOverseaBuyNumber] = useState(null);
  const [isShowGroupProduct, setIsShowGroupProduct] = useState(false);
  const [isShowBuyGroupProductDialog, setIsShowBuyGroupProductDialog] = useState(false);
  const [isShowSecondKillDialog, setIsShowSecondKillDialog] = useState(false);
  const [buyCartloading, setBuyCartloading] = useState(false);
  const [isShowMateriel, setIsShowMateriel] = useState(false);
  const [originPrice, setOriginPrice] = useState(null);
  const [price, setPrice] = useState(null);
  const [productUnitInfo, setproductUnitInfo] = useState({
    gdProductUnit: data?.productRecord?.productUnit,
  });
  const [isBtnHover, setBtnHover] = useState(false);
  const [numberTipText, setNumberTipText] = useState({
    gdNumberTipText: '',
    overseaNumberTipText: '',
  });
  const [isShowNumberTip, setIsShowNumberTip] = useState({
    isShowGdNumberTip: false,
    isShowJsNumberTip: false,
    isShowOverseaNumberTip: false,
  });
  const [purchaseCount, setPurchaseCount] = useState('');
  const [showPriceInquiryModal, setShowPriceInquiryModal] = useState(false);

  const [isClient, setIsClient] = useState(false);
  const { productStockPriceData } = useProductStore();

  useEffect(() => {
    setIsClient(true);
  }, []);

  let gdNum = null;
  let overseaNum = null;
  const totalPriceText = useRef(null);
  const addBtnRef = useRef(null);
  const buyBtnRef = useRef(null);

  // 显示立创订货
  const isOverseaShowLcDh = !productRecord?.stockNumber && data?.isOversea;
  const isShowLcDh = useMemo(() => {
    return (
      !productStockPriceData?.jsWarehouseStockNumber &&
      !productStockPriceData?.gdWarehouseStockNumber &&
      !data?.isOversea
    );
  }, [productStockPriceData, data]);

  const changePriceInquiryModal = (value) => {
    setShowPriceInquiryModal(value);
  };

  // 获取所有的数量
  const getTotalNumber = () => {
    if (data?.isOversea) {
      return { totalNumber: Number(overseaNum) || Number(overseaBuyNumber) };
    } else {
      // 整包数量
      const productMinEncapsulationNumber = productRecord?.productMinEncapsulationNumber;
      // 包装方式
      const productMinEncapsulationUnit = productRecord?.productMinEncapsulationUnit;
      let gdNumber = Number(gdNum) || Number(gdBuyNumber);

      // 判断包装方式是否是整包等
      if (productUnitInfo.gdProductUnit === productMinEncapsulationUnit) {
        gdNumber = gdNumber * productMinEncapsulationNumber;
      }
      const totalNumber = Number(gdNumber);
      return { totalNumber, gdNumber };
    }
  };
  // 获取对应数量的价格
  const getComputedPrice = () => {
    // 价格区间
    let price = 0;
    const minBuyNumber = getTotalNumber().totalNumber;
    const theRatio = productRecord?.theRatio || 1;
    if (data?.isOversea) {
      const tieredPrices = productRecord?.tieredPrices;
      const discountTieredPrices = productRecord?.discountTieredPrices;
      if (discountTieredPrices && discountTieredPrices?.length > 0) {
        price = discountTieredPrices[0].discountPrice;
        // 根据购买数量判断价格区间取什么价格
        discountTieredPrices?.forEach((v) => {
          if (v.countStart <= minBuyNumber && (v.countEnd >= minBuyNumber || v.countEnd == null)) {
            price = v.discountPrice;
          }
        });
        getDiscountMoney();
      } else if (tieredPrices && tieredPrices?.length > 0) {
        price = tieredPrices[0].price;
        // 根据购买数量判断价格区间取什么价格
        tieredPrices?.forEach((v) => {
          if (
            v.countStart * theRatio <= minBuyNumber &&
            (v.countEnd * theRatio >= minBuyNumber || v.countEnd == null)
          ) {
            price = v.price;
          }
        });
      }
    } else {
      const productPriceList = productStockPriceData?.productRecord?.productPriceList;
      const productPriceDiscountList = productStockPriceData?.productRecord?.productPriceDiscountList?.[0]?.priceList;
      if (productPriceDiscountList && productPriceDiscountList?.length > 0) {
        price = productPriceDiscountList[0].price;
        // 根据购买数量判断价格区间取什么价格
        productPriceDiscountList?.forEach((v) => {
          if (v.spNumber * theRatio <= minBuyNumber && (v.epNumber * theRatio >= minBuyNumber || v.epNumber == -1)) {
            price = v.price;
          }
        });
        getDiscountMoney();
      } else if (productPriceList && productPriceList?.length > 0) {
        price = productPriceList[0].productPrice;
        // 根据购买数量判断价格区间取什么价格
        productPriceList?.forEach((v) => {
          if (
            v.startPurchasedNumber * theRatio <= minBuyNumber &&
            (v.endPurchasedNumber * theRatio >= minBuyNumber || v.endPurchasedNumber == -1)
          ) {
            price = v.productPrice;
          }
        });
      }
    }
    setPrice(price);
    return price;
  };
  // 获取对应数量的优惠价格
  const getDiscountMoney = () => {
    // 计算已优惠价格
    let discountMoney = 0;
    let originPrice = 0;
    const theRatio = productRecord?.theRatio || 1;
    const cartNum = getTotalNumber().totalNumber;
    if (data?.isOversea) {
      const discountTieredPrices = productRecord?.discountTieredPrices;
      const priceItem =
        discountTieredPrices?.find((item) => item.countStart <= cartNum && item.countEnd >= cartNum) ||
        discountTieredPrices[discountTieredPrices?.length - 1];
      discountMoney = MultiAccurate(SubAccurate(priceItem?.price || 0, priceItem?.discountPrice || 0), cartNum);
      originPrice = MultiAccurate(Number(priceItem?.price), cartNum);
    } else {
      const productPriceList = productStockPriceData?.productRecord?.productPriceList;
      const productPriceDiscountList = productStockPriceData?.productRecord?.productPriceDiscountList?.[0]?.priceList;
      const discountPriceItem = productPriceDiscountList?.find(
        (item) => item.spNumber * theRatio <= cartNum && (item.epNumber * theRatio >= cartNum || item.epNumber == -1)
      );
      const priceItem = productPriceList?.find(
        (item) =>
          item.startPurchasedNumber * theRatio <= cartNum &&
          (item.endPurchasedNumber * theRatio >= cartNum || item.endPurchasedNumber == -1)
      );

      discountMoney = MultiAccurate(SubAccurate(priceItem?.productPrice || 0, discountPriceItem?.price || 0), cartNum);
      originPrice = MultiAccurate(Number(priceItem?.productPrice), cartNum);
    }

    setOriginPrice(Utils.priceRound(originPrice, 2));
    setDiscountMoney(Utils.priceRound(discountMoney, 2));
  };
  // 计算总价
  const getComputedTotalPrice = () => {
    let totalPrice = 0;
    const price = getComputedPrice();
    if (data?.isOversea) {
      totalPrice = Utils.priceRound(overseaBuyNumber * price, 2);
    } else {
      let gdPrice = 0;
      if (productUnitInfo.gdProductUnit === productRecord?.productMinEncapsulationUnit) {
        gdPrice = Utils.priceRound(gdBuyNumber * price * productRecord?.productMinEncapsulationNumber, 2);
      } else {
        gdPrice = Utils.priceRound(gdBuyNumber * price, 2);
      }
      totalPrice = Utils.priceRound(gdPrice, 2);
    }
    return totalPrice.toFixed(2);
  };

  const totalPrices = useMemo(() => {
    const price = getComputedTotalPrice();
    totalPriceText.current = price;
    return price;
  }, [gdBuyNumber, productUnitInfo.gdProductUnit, overseaBuyNumber]);

  // 页面组件
  const buttonMouseEnter = () => {
    setBtnHover(true);
  };
  const buttonMouseLeave = () => {
    setBtnHover(false);
    setIsShowGroupProduct(false);
  };

  const handleHoverChange = (open) => {
    if (data?.isSecondKill || data?.isGroupProduct) {
      setIsShowGroupProduct(open);
    } else {
      setIsShowGroupProduct(false);
    }
  };

  // 按钮
  const AddCardAndBuyButton = memo(() => {
    const buttonClass =
      'w-[160px] h-[48px] border-[#ABB5C9] hover:text-[rgba(57,74,111,0.8)] border-[1px] bg-[#F6F7F9] rounded-l-[30px] text-[16px] leading-[48px] text-[#394A6F]';
    return (
      <Spin indicator={<LoadingOutlined spin />} size="small" spinning={buyCartloading}>
        <div className="relative mt-[12px] flex justify-between w-[100%] rounded-[30px]">
          <button
            ref={addBtnRef}
            data-spm="iad"
            id="addCartBtn-product"
            className={`${buttonClass}  ${
              data?.isOversea && productRecord?.stockNumber < productRecord?.minBuyNumber ? 'cursor-not-allowed' : ''
            }`}
            onClick={clickToCart}
          >
            加入购物车
          </button>
          <div
            className={`absolute left-[144px] z-50 h-[20px] w-[20px] border-t-[1px] border-solid border-[#ABB5C9] bg-[#F6F7F9]`}
          ></div>
          <div
            className={` absolute left-[155px] top-[0px] z-50 h-[48px] w-[8px] skew-x-[-15deg] bg-[white] lc-flex-center ${data?.isGroupProduct ? 'lc-pt-button-border' : 'lc-button-border'}  `}
          >
            <div className="skew-x-[15deg]"></div>
          </div>
          <div className={`${isBtnHover ? 'hover:opacity-80' : ''}`}>
            <div
              className={`absolute h-[48px] w-[25px] ${data?.isGroupProduct ? 'bg-[#199FE9]' : 'bg-[#FF4960]'} left-[157px]`}
            ></div>
            <Popover
              placement="bottom"
              content={
                data?.isSecondKill ? (
                  <SecondKillModel secondKillProductVO={data?.secondKillProductVO} />
                ) : (
                  <CountdownModel groupActivityProductVO={data?.groupActivityProductVO} />
                )
              }
              trigger="hover"
              open={isShowGroupProduct}
              onOpenChange={(e) => handleHoverChange(e)}
            >
              <button
                id={data?.isGroupProduct ? 'item-addgroup' : productRecord?.selfProductCode ? '' : 'item-buy'}
                ref={buyBtnRef}
                className={`ml-[0px] h-[48px] w-[160px] ${data?.isGroupProduct ? 'bg-[#199FE9]' : 'bg-[#FF4960]'} rounded-r-[30px] border-none text-[16px] leading-[48px] text-[#F7F7F7]`}
                onMouseEnter={buttonMouseEnter}
                onMouseLeave={buttonMouseLeave}
                onClick={clickToBuy}
                data-spm="buy"
              >
                {data?.isGroupProduct
                  ? data?.groupActivityProductVO?.recommendLevel === 'B' ||
                    data?.groupActivityProductVO?.recommendLevel === 'C'
                    ? '我要订货'
                    : '购买立推'
                  : isShowLcDh || isOverseaShowLcDh
                    ? '立即订货'
                    : data?.isSecondKill
                      ? '秒杀'
                      : '立即购买'}
              </button>
            </Popover>
          </div>
        </div>
      </Spin>
    );
  });
  AddCardAndBuyButton.displayName = 'AddCardAndBuyButton';

  // 按钮
  const DisabledButton = ({ children }) => {
    return (
      <div className="relative mt-[12px] flex w-[100%] rounded-[30px] bg-[#F6F7F9]">
        <button
          disabled={true}
          className="h-[48px] w-[100%] cursor-not-allowed rounded-[30px] border-[1px] border-[#ABB5C9] bg-[#F6F7F9] text-[16px] leading-[48px]"
        >
          {children}
        </button>
      </div>
    );
  };
  DisabledButton.displayName = 'DisabledButton';

  const PriceButton = memo(() => {
    const handleInquiryPrice = async () => {
      if (userInfo?.customerLogin !== 1) {
        Utils.showWindowLogin();
        return false;
      }
      const { productMinEncapsulationUnit, productMinEncapsulationNumber } = data?.productRecord || {};
      // 获取实际数量
      const buyNumber = data?.isOversea ? overseaBuyNumber : gdBuyNumber;
      if (
        !data?.isOversea &&
        productUnitInfo.gdProductUnit &&
        productMinEncapsulationUnit &&
        productUnitInfo.gdProductUnit === productMinEncapsulationUnit
      ) {
        setPurchaseCount(buyNumber * productMinEncapsulationNumber);
      } else {
        setPurchaseCount(buyNumber);
      }
      let params;
      if (data?.productRecord?.selfProductCode) {
        // 判断是否P转C
        params = {
          selfProductCode: data?.productRecord?.selfProductCode,
          selfProductId: data?.productRecord?.selfProductId,
          provider: data?.productRecord?.provider,
          productCodeProvider: data?.productRecord?.productCodeProvider,
          productCodeManufacturer: data?.productRecord?.productCodeManufacturer,
          vendorCode: data?.productRecord?.vendorCode,
        };
      } else if (data?.productRecord?.provider) {
        // 存在provider即为订货或海外代购
        params = {
          provider: data?.productRecord?.provider,
          productCodeProvider: data?.productRecord?.productCodeProvider,
          productCodeManufacturer: data?.productRecord?.productCodeManufacturer,
          vendorCode: data?.productRecord?.vendorCode,
        };
      } else {
        // 现货
        params = {
          productId: data?.productRecord?.productId,
          productCode: data?.productRecord?.productCode,
        };
      }
      const res = await asyncCheckNoPriceEnquiry(params);
      if (res?.needLogin || res?.msg === 'needLogin') {
        Utils.showWindowLogin();
        return false;
      }
      if (res?.code === 200) {
        changePriceInquiryModal(true);
      } else {
        lcMsgTips.showConfirmModal({
          title: res?.msg,
        });
      }
    };

    let currentContent = <></>;
    if (productRecord?.productUnsealVendition === 'no') {
      currentContent = <DisabledButton>商品不可售</DisabledButton>;
    } else if (
      ['sold_out', 'stop_product'].includes(productRecord?.productCycle) &&
      productRecord.productStockStatus === 'no'
    ) {
      currentContent = <DisabledButton>商品停售</DisabledButton>;
    } else if (data?.productRecord?.isShowPrice === false) {
      currentContent = (
        <button
          className="w-full h-[48px] rounded-[12px] bg-[#0093E6] text-[16px] text-[#ffffff] hover:opacity-[0.6]"
          onClick={handleInquiryPrice}
        >
          我要询价
        </button>
      );
    } else {
      currentContent = (
        <>
          <div className="leading-[24px]">
            {discountMoney > 0 && originPrice > 0 && (
              <div className="flex justify-between text-[14px] mb-[10px]">
                <span className="font-bold text-[#000000]">
                  原价：<span className="text-[#B8BEC9] line-through font-normal">￥{originPrice}</span>
                </span>
                <span className="font-bold text-[#000000]">
                  已优惠：<span className="text-[#FF4960] font-normal">￥{discountMoney}</span>
                </span>
              </div>
            )}
            <h3 className="inline text-[14px] font-bold text-[#000000]">总价金额： </h3>
            <span className="text-[18px] font-bold text-[#FF4960]">
              ￥ <span className="text-[22px]">{totalPrices}</span>
            </span>
          </div>
          <AddCardAndBuyButton />
        </>
      );
    }

    return (
      <div className="mt-[20px] mb-[30px]">
        {currentContent}
        {!data?.isOversea && (
          <p className="mt-[8px] text-[12px] text-[#000000]">
            <SoundOutlined className="mr-[5px] h-[12px] w-[14px] text-[#69788A]" />
            <span className="text-[#69788A]">近期成交</span>
            {/* eslint-disable-next-line */}
            {data?.recentlySalesCount > 100 ? '100+' : data?.recentlySalesCount}单
          </p>
        )}
      </div>
    );
  });
  PriceButton.displayName = 'PriceButton';

  // 立即下单
  const clickToBuy = () => {
    // 我要订货
    setIsShowGroupProduct(false);
    if (data?.isGroupProduct) {
      clickGroupProduct();
    } else if (data?.isSecondKill) {
      clickSecondKill();
    } else {
      clickBuyNow();
    }
  };
  // 秒杀
  const clickSecondKill = () => {
    setIsShowSecondKillDialog(true);
  };
  // 立推
  const clickGroupProduct = () => {
    setIsShowBuyGroupProductDialog(true);
  };
  // 立即购买
  const clickBuyNow = () => {
    const isPass = checkAmendNum();
    if (isPass) {
      let params = {};
      const { totalNumber } = getTotalNumber();
      if (data?.isOversea || productRecord?.selfProductCode) {
        if (productRecord?.selfProductCode) {
          const lcBookProductVO = productRecord?.lcBookProductVO || {};
          params = {
            purchaseNumber: totalNumber / productRecord?.theRatio,
            provider: lcBookProductVO?.provider,
            productCodeProvider: lcBookProductVO?.productCodeProvider,
            vendorCode: lcBookProductVO?.vendorCode,
            batchNumber: lcBookProductVO?.batchNum,
            productRegion: lcBookProductVO?.productRegion,
            placeOfOrigin: lcBookProductVO?.placeOfOrigin,
            productCodeManufacturer: lcBookProductVO?.productCodeManufacturer,
            sourcePartId: productRecord?.sourcePartId,
            selfProductCode: productRecord?.productCode,
            trackZone: fromZone,
          };
        } else {
          params = {
            provider: productRecord?.provider,
            productCodeProvider: productRecord?.productCodeProvider,
            vendorCode: productRecord?.vendorCode,
            productRegion: productRecord?.productRegion,
            placeOfOrigin: productRecord?.placeOfOrigin,
            productCodeManufacturer: productRecord?.productCodeManufacturer,
            purchaseNumber: overseaBuyNumber / productRecord?.theRatio,
            sourcePartId: productRecord?.sourcePartId,
            trackZone: fromZone,
            batchNumber: productRecord?.batchNumber,
          };
        }
      } else {
        params = {
          productId: productRecord.productId,
          purchaseNumber: Number(totalNumber) / (productRecord?.convesionRatio || 1),
        };
      }
      buriedPoint({
        cp: 'product_detail',
        ty: 'click',
        op: 'BUY_NOW',
        data: {
          track_zone: fromZone,
          pc: productRecord.productId,
          no: totalNumber,
          sence: 'buy_now',
          type: productRecord?.provider,
          price: totalPriceText.current,
        },
      });
      setBuyCartloading(true);
      sendAxios({
        method: 'post',
        url: API.asyncMemberDetailPerfect,
        baseURL: 'lcscOrderApiUrl',
        data: params,
      })
        .then((res) => {
          if (res.needLogin) {
            gotoLogin();
          }
          if (res.code == 200) {
            // 海外代购
            const isOversea = data?.isOversea;
            // 立创订货
            const providerIsLCDH = lcBookProvider.includes(data?.provider);
            if (isOversea && !providerIsLCDH) {
              setIsShowMateriel(true);
            } else {
              if (data?.isHkRmb) {
                window.open(getMemberPerfectUrl('hkRmb'), '_blank');
              } else if (data?.isHkUsd) {
                window.open(getMemberPerfectUrl('hkUsd'), '_blank');
              } else {
                window.open(getMemberPerfectUrl('base'), '_blank');
              }
            }
          } else if (res.msg) {
            message.error(res.msg);
          }
        })
        .finally(() => {
          setBuyCartloading(false);
        });
    }
  };

  const handleChangeCheck = () => {
    if (data?.isHkRmb) {
      window.open(getMemberPerfectUrl('hkRmb'), '_blank');
    } else if (data?.isHkUsd) {
      window.open(getMemberPerfectUrl('hkUsd'), '_blank');
    } else {
      window.open(getMemberPerfectUrl('base'), '_blank');
    }
  };

  const getMemberPerfectUrl = (type) => {
    const MemberPerfectBaseUrls = {
      base: `${projectConfigVO.lcscOrderUrl}/member/perfect.html?sence=item`,
      hkRmb: `${projectConfigVO.lcscOrderUrl}/member/perfect/hk/rmb.html?sence=item`,
      hkUsd: `${projectConfigVO.lcscOrderUrl}/member/perfect/hk/usd.html?sence=item`,
    };
    let baseUrl = MemberPerfectBaseUrls[type];
    if (fromZone) {
      baseUrl += `&trackZone=${fromZone}`;
    }
    const finalUrl = Utils.getBtnSpmQueryUrl(baseUrl, buyBtnRef.current);
    return finalUrl;
  };

  // 跳登录和注册
  const gotoLogin = (type) => {
    const url = Utils.getCasTypeUrl(type);
    window.open(url, '_self');
  };
  // 倍数购买
  const checkTheRatioFn = (type) => {
    let isPass = true;
    const { gdNumber, totalNumber } = getTotalNumber();
    const theRatio = productRecord?.theRatio || 1;
    if (type !== 'oversea') {
      setIsShowNumberTip({ ...isShowNumberTip, isShowGdNumberTip: true });
      setGdBuyNumber(Number(theRatio) * Math.ceil(gdNumber / theRatio));
      gdNum = Number(theRatio) * Math.ceil(gdNumber / theRatio);
      setNumberTipText({
        ...numberTipText,
        gdNumberTipText: `必须以${theRatio}的倍数购买，已为您修正。`,
      });
      setTimeout(() => setIsShowNumberTip({ ...isShowNumberTip, isShowGdNumberTip: false }), 3000);
      isPass = false;
    } else {
      setIsShowNumberTip({ ...isShowNumberTip, isShowOverseaNumberTip: true });
      setOverseaBuyNumber(Number(theRatio) * Math.ceil(totalNumber / theRatio));
      overseaNum = Number(theRatio) * Math.ceil(totalNumber / theRatio);
      setNumberTipText({
        ...numberTipText,
        overseaNumberTipText: `必须以${theRatio}的倍数购买，已为您修正。`,
      });
      setTimeout(
        () =>
          setIsShowNumberTip({
            ...isShowNumberTip,
            isShowOverseaNumberTip: false,
          }),
        3000
      );
      isPass = false;
    }
    return isPass;
  };
  // 输入数量修正
  const checkAmendNum = () => {
    let isPass = true;
    const { gdNumber, totalNumber } = getTotalNumber();
    const minBuyNumber = productRecord.selfProductCode
      ? productRecord?.minBuyNumber
      : productRecord?.minBuyNumber * productRecord?.theRatio;
    const theRatio = productRecord?.theRatio || 1;
    if (data?.isOversea) {
      if (!totalNumber) {
        message.warning('请填写购买数量');
        return false;
      }
      if (totalNumber < productRecord?.minBuyNumber) {
        message.warning(`最低起订量：${productRecord?.minBuyNumber}`);
        return false;
      }
      if (totalNumber % theRatio !== 0) {
        isPass = checkTheRatioFn('oversea');
      }
      return isPass;
    } else {
      if (!gdNumber) {
        message.warning('请填写购买数量');
        return false;
      }
      if (totalNumber < minBuyNumber) {
        message.warning(`最低起订量：${minBuyNumber}`);
        return false;
      }
      if (theRatio !== 1 && gdNumber % theRatio !== 0) {
        isPass = checkTheRatioFn('gd');
      }

      return isPass;
    }
  };

  const checkAddCartAmendNum = () => {
    const { gdNumber, totalNumber } = getTotalNumber();
    const minBuyNumber = productRecord?.minBuyNumber;
    const theRatio = productRecord?.theRatio || 1;
    if (data?.isOversea) {
      if (!totalNumber || totalNumber < productRecord?.minBuyNumber) {
        setIsShowNumberTip({
          ...isShowNumberTip,
          isShowOverseaNumberTip: true,
        });
        setOverseaBuyNumber(productRecord?.minBuyNumber);
        overseaNum = productRecord?.minBuyNumber;
        setNumberTipText({
          ...numberTipText,
          overseaNumberTipText: `最小起订量为${productRecord?.minBuyNumber}，已为您修正。`,
        });
        setTimeout(
          () =>
            setIsShowNumberTip({
              ...isShowNumberTip,
              isShowOverseaNumberTip: false,
            }),
          3000
        );
      }
      if (totalNumber > productRecord?.stockNumber) {
        setIsShowNumberTip({
          ...isShowNumberTip,
          isShowOverseaNumberTip: true,
        });
        setNumberTipText({
          ...numberTipText,
          overseaNumberTipText: `海外代购暂不支持订货！`,
        });
        setTimeout(
          () =>
            setIsShowNumberTip({
              ...isShowNumberTip,
              isShowOverseaNumberTip: false,
            }),
          3000
        );
      }
      if (data?.isOversea && totalNumber % theRatio !== 0) {
        checkTheRatioFn('oversea');
      }
    } else {
      // 获取购买数量
      if (!gdNumber) {
        setIsShowNumberTip({ ...isShowNumberTip, isShowGdNumberTip: true });
        setGdBuyNumber(productRecord.selfProductCode ? minBuyNumber : minBuyNumber * theRatio);
        gdNum = productRecord.selfProductCode ? minBuyNumber : minBuyNumber * theRatio;
        setNumberTipText({
          ...numberTipText,
          gdNumberTipText: `最小起订量为${productRecord.selfProductCode ? minBuyNumber : minBuyNumber * theRatio}，已为您修正。`,
        });
        setTimeout(
          () =>
            setIsShowNumberTip({
              ...isShowNumberTip,
              isShowGdNumberTip: false,
            }),
          3000
        );
      }
      if (theRatio !== 1 && gdNumber % theRatio !== 0) {
        checkTheRatioFn('gd');
      }
    }
  };

  // 加入购物车
  const clickToCart = async () => {
    checkAddCartAmendNum();
    if (data?.isOversea) {
      overseaAddCart();
    } else {
      localAddCart();
    }
  };

  const localAddCart = () => {
    const { totalNumber } = getTotalNumber();
    const { lcsc_vid = '', spm = '' } = Utils.getButtonParams(addBtnRef.current);
    const currencyType = 'RMB';
    const deliveryPoint = 'CN';
    const convesionRatio = productRecord?.convesionRatio || 1;
    const productId = productRecord?.productId;
    const str = '0~' + productId + '~' + currencyType + '~' + deliveryPoint + '~' + totalNumber / convesionRatio;
    // 正常普通加购
    let url = API.cartAddNormal;
    let paramData = {
      cartKeyStr: str,
      entryType: 'item_details',
      trackZone: fromZone,
      lcscVid: lcsc_vid,
      spm,
    };
    // C转P
    if (productRecord?.lcBookProductVO && productRecord?.lcBookProductVO?.provider) {
      const lcBookProductVO = productRecord?.lcBookProductVO;
      url = API.asyncAddOverseasBrokage;
      paramData = {
        purchaseNumber: totalNumber / productRecord?.theRatio,
        provider: lcBookProductVO?.provider,
        productCodeProvider: lcBookProductVO?.productCodeProvider,
        vendorCode: lcBookProductVO?.vendorCode,
        batchNumber: lcBookProductVO?.batchNum,
        productRegion: lcBookProductVO?.productRegion,
        placeOfOrigin: lcBookProductVO?.placeOfOrigin,
        productCodeManufacturer: lcBookProductVO?.productCodeManufacturer,
        sourcePartId: productRecord?.sourcePartId,
        selfProductCode: productRecord?.productCode,
        lcscVid: lcsc_vid,
        spm,
      };
    }
    buriedPoint({
      cp: 'product_detail',
      ty: 'click',
      op: 'ADD_CART',
      data: {
        track_zone: fromZone,
        pc: productRecord.productId,
        no: totalNumber, // 双仓总量
        type: 'main_products',
        xh: productRecord.productModel,
        price: totalPriceText.current,
      },
    });
    setBuyCartloading(true);
    sendAxios({
      method: 'post',
      baseURL: 'lcscCartApiUrl',
      data: paramData,
      url,
    })
      .then((res) => {
        if (res.needLogin) {
          gotoLogin();
        }
        if (res.shifting) {
          message.error(res.shifting);
        } else if (res.msg && res.msg.indexOf('needLogin') >= 0) {
          gotoLogin();
        } else if (res.code === 200) {
          message.success('加入购物车成功！');
          updateUserInfo({
            ...userInfo,
            cartNum: res.result.cart_contains_count,
          });
        } else {
          message.error(res.msg);
        }
      })
      .catch((error) => {
        message.error(error.msg);
      })
      .finally(() => {
        setBuyCartloading(false);
      });
  };

  const overseaAddCart = () => {
    const { totalNumber } = getTotalNumber();
    const theRatio = productRecord?.theRatio || 1;
    if (data?.isOversea && productRecord?.stockNumber < productRecord?.minBuyNumber) {
      message.error('库存不足，无法立即下单');
      return;
    }
    if (totalNumber > productRecord?.stockNumber) {
      return;
    }
    if (totalNumber % theRatio !== 0) {
      return;
    }
    if (data?.provider === 'mouser') {
      setBuyCartloading(true);
      sendAxios({
        method: 'get',
        baseURL: 'lcscCartApiUrl',
        url: `${API.getMouseStock}?provider=${data?.provider}&productModel=${data?.productCodeProvider}`,
      })
        .then((res) => {
          if (res.code === 200 && res.result) {
            handleAddCart();
          }
        })
        .catch((error) => {
          if (error.code === 405) {
            message.error(`${error.msg}, 请重新加载！`);
          }
          if (error.msg === 'needLogin') {
            gotoLogin();
          }
        });
    } else {
      handleAddCart();
    }
  };

  const handleAddCart = () => {
    const { totalNumber } = getTotalNumber();
    const { lcsc_vid = '', spm = '' } = Utils.getButtonParams(addBtnRef.current);
    const param = {
      purchaseNumber: totalNumber / productRecord?.theRatio,
      provider: productRecord?.provider,
      productCodeProvider: productRecord?.productCodeProvider,
      vendorCode: productRecord?.vendorCode,
      batchNumber: productRecord?.batchNumber,
      productRegion: productRecord?.productRegion,
      placeOfOrigin: productRecord?.placeOfOrigin,
      productCodeManufacturer: productRecord?.productCodeManufacturer,
      sourcePartId: productRecord?.sourcePartId,
      trackZone: fromZone,
      lcscVid: lcsc_vid,
      spm,
    };
    buriedPoint({
      cp: 'product_detail',
      ty: 'click',
      op: 'ADD_CART',
      data: {
        track_zone: fromZone,
        xh: productRecord?.productCodeManufacturer,
        no: totalNumber,
        type: productRecord?.provider,
        price: totalPriceText.current,
      },
    });
    sendAxios({
      method: 'post',
      baseURL: 'lcscCartApiUrl',
      data: param,
      url: API.asyncAddOverseasBrokage,
    })
      .then((res) => {
        if (res.needLogin) {
          gotoLogin();
          return;
        }
        if (res.code == 200) {
          message.success('加入购物车成功！');
        } else {
          if (res.msg !== 'needLogin') {
            message.error(res.msg);
          }
        }
      })
      .catch(() => {
        message.error('系统繁忙, 请联系客服人员或稍后再试！');
      })
      .finally(() => {
        setBuyCartloading(false);
      });
  };
  // 优惠活动
  const isShowDiscountList = data?.productDiscountList?.length > 0;
  // plus会员
  const isPlus = data?.hasPlusCoupon && !data?.isCouponUnavailable;
  // 返采购晶标
  const isRebase = data?.isProductRebate && !data.isGuidePrice;
  // 福利兑换活动
  const isWelf = data?.productWelfareList?.length > 0;
  // 优惠券
  const isCoupon = data?.productCouponList?.length > 0;
  const isShowActiveCoupon = isShowDiscountList || isPlus || isRebase || isWelf || isCoupon;

  // 骨架屏加载判断条件
  const isLoading = (!data?.isOversea && !productStockPriceData.isFetched) || (data?.isOversea && !isClient);

  return (
    <section className="ml-[20px] w-[370px] rounded-[20px] bg-[#FFFFFF] px-[20px] pt-[20px]" data-spm="gm">
      {isLoading ? (
        <ItemRightSkeleton />
      ) : (
        <>
          {/* 梯度价格模块 */}
          <PriceListPage data={data} />
          {/* 优惠活动模块 - 自营（非海外代购和P转C） */}
          {!data?.isOversea && !productRecord?.selfProductCode && isShowActiveCoupon && (
            <ProductDiscountActivity data={data} totalNumber={getTotalNumber()?.totalNumber} price={price} />
          )}
          {/* 优惠活动模块 - 海外代购 */}
          {data?.isOversea && <OvseaProductDiscountActivity data={data} />}
          {/* 库存总量模块 */}
          {productRecord?.productUnsealVendition !== 'no' && <InventoryComponents data={data} />}
          <DeliveryTime data={data} />
          {/* 购买数量模块 */}
          <NumberOfPurchases
            productRecord={data?.productRecord}
            numberTipText={numberTipText}
            isShowNumberTip={isShowNumberTip}
            productUnitInfo={productUnitInfo}
            setproductUnitInfo={setproductUnitInfo}
            setGdBuyNumber={setGdBuyNumber}
            setOverseaBuyNumber={setOverseaBuyNumber}
            gdBuyNumber={gdBuyNumber}
            overseaBuyNumber={overseaBuyNumber}
          />
          <PriceButton />
        </>
      )}
      {/* 点击立推弹窗 */}
      {isShowBuyGroupProductDialog && (
        <BuyGroupProductDialog
          data={data}
          isShowBuyGroupProductDialog={isShowBuyGroupProductDialog}
          setIsShowBuyGroupProductDialog={(val) => setIsShowBuyGroupProductDialog(val)}
        />
      )}
      {isShowSecondKillDialog && (
        <SecondKillDialog
          data={data}
          isShowSecondKillDialog={isShowSecondKillDialog}
          setIsShowSecondKillDialog={(val) => setIsShowSecondKillDialog(val)}
        />
      )}
      <SellAbroadModel
        isShowMateriel={isShowMateriel}
        setIsShowMateriel={setIsShowMateriel}
        handleChangeCheck={handleChangeCheck}
      />
      {showPriceInquiryModal && (
        <PriceInquiryModal
          showModal={showPriceInquiryModal}
          changeShowModal={changePriceInquiryModal}
          purchaseCount={purchaseCount}
          currentItem={data?.productRecord}
          totalStockNumber={data?.totalStockNumber}
        />
      )}
    </section>
  );
}
